// extracted by mini-css-extract-plugin
export default {"products":"aw-z","card":"bw-z","oosMessaging":"cw-z"};